<template>
  <div class="col-sm-5 mt-3">
            <label>Choose a customer</label>
            <select
              name="cust-select"
              class="form-control m-1 float-right"
              v-model="custId"
              @click="sendCustId(custId)"
            >
                <option
                v-for="customer in customers"
                v-bind:key="customer._id"
                :value="customer._id"
              >
                {{ customer.name }}
              </option>
            </select>
          </div>
</template>

<script>
import { apiCall } from "@/utils/api";
export default {
mounted(){
 this.getAllCustomers();
},
data(){
    return {
        customers : [],
        custId : '' ,
        name : ''
    }
},
methods : {
getAllCustomers() {
      apiCall({ url: "company", method: "get" }).then((result) => {
        if(result.data.length)
        this.customers = result.data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      });
    },
sendCustId(custId){
  if(custId)
  this.$emit("sendCustomer", custId)
},
}
}
</script>

<style scoped>
.form-control {
    display: block;
    width: 100%;
    padding: .375rem .75rem;
    font-size: 0.9rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 2px solid #17a2b8;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
</style>